import { AuthorWidget } from './AuthorWidget';

export default AuthorWidget;
